<script>
import { required } from 'vuelidate/lib/validators'
export default {
  name: 'shared.select-customer.step',
  props: {
    value: { type: Object, default: () => {} }
  },
  data: vm => ({
    form: {
      customer_account_id: '',
      ...vm.value
    }
  }),
  validations: {
    form: {
      customer_account_id: {
        required
      }
    }
  },
  methods: {
    validate () {
      if (!this.$v && !this.$v.form) return true
      this.$v.form.$touch()
      if (!this.$v.form.$invalid) {
        this.$emit('validated', { ...this.form })
        this.$emit('input', { ...this.form })
      }

      return !this.$v.form.$invalid
    }
  }
}
</script>
<template>
  <b-card no-body class="shadow-none">
    <g-form-error-wrapper :validations="$v.form.customer_account_id">
      <template v-slot="{ errors, invalid }">
        <app-customer-select
          v-model="form.customer_account_id"
          v-on:blur="$v.form.customer_account_id.$touch()"
        />
      </template>
    </g-form-error-wrapper>
  </b-card>
</template>
